import { useEffect, useState } from "react";
import { getSubCateLinks } from "../../utils/requests/subcate";
import { usePathname } from 'next/navigation'
import { useRouter } from 'next/router'

export type SubcateLinksProps = { 
    t: any, 
    locale: string, 
    actionid: string, 
    categoryid: string,
    showListPathIds: any,
    searchParamsList: any,
    actionsList: any,
    categoryList: any
};

import styles from './SubcateLinks.module.scss';
import Link from "next/link";
import { set } from "lodash";

export const SubcateLinks = (props: SubcateLinksProps) => {

    const { t, locale, actionid, categoryid, showListPathIds,
        searchParamsList,
        actionsList,
        categoryList
    } = props;
    const pathname = usePathname();  
    const router = useRouter()

    debugger;

    const [subcates, setSubCates] = useState({});
   
    useEffect(() => {
        const load = async () => {

            const { province, amphur, 
                locationid, 
                locationtypeid,
                locationbranchid } = searchParamsList;

            if(!actionid || !categoryid) {
                processNoActionIdOrCategoryId(actionid, categoryid, 
                    actionsList, categoryList, locale, setSubCates);
            } else {
            
                const links = await getSubCateLinks(locale, 
                    actionid, 
                    categoryid,
                    province,
                    amphur,
                    locationtypeid,
                    locationbranchid
                )
                links?.data && setSubCates(links.data)
            }
        }

        load();
    }, [searchParamsList])


    const processNoActionIdOrCategoryId = (actionid: string, categoryid: string, 
        actionsList: any, categoryList: any, locale: string, setSubCates) => {

     
        const links = {};

        if (!actionid) {
            actionsList?.data?.map((action) => {
                links[action.action] = categoryList?.data?.map((cate) => {

                    return {
                        name: `${action.action} ${cate[`category_Name_${locale.toUpperCase()}`]}`,
                        url: {
                            full: `${action.action}/${cate[`category_Name_${locale.toUpperCase()}`]}`
                        }
                    };
                });
            });
        } else {
            const action = actionsList?.data?.find(a => a.id === actionid);
            console.log('no actionid or categoryid: ', actionid, categoryid, actionsList, categoryList, action);
            if (action) {
                links[action.action] = categoryList?.data?.map((cate) => {

                    return {
                        name: `${action.action} ${cate[`category_Name_${locale.toUpperCase()}`]}`,
                        url: {
                            full: `${action.action}/${cate[`category_Name_${locale.toUpperCase()}`]}`
                        }
                    };
                });
            }
        }
        setSubCates(links);
    }

    const genSubcate = (items) => {

        if(!items) return;
        
        if(!router?.asPath) return;

        const {
            group_category_name_url,
            sub_category_name_url 
        } = searchParamsList;

        const url = new URL(`${window.location.href}`)
        url.search = '';


        console.log('subcatelinks: ', searchParamsList,
            url.pathname, items, url.toString());

        let onlySeoUrl = decodeURIComponent(url.pathname);
        if(searchParamsList.group_category_id && group_category_name_url) {
            onlySeoUrl = onlySeoUrl.replace(`/${group_category_name_url}`, '')
        }
        if(searchParamsList.subCategoryId && sub_category_name_url) {
            onlySeoUrl = onlySeoUrl.replace(`/${sub_category_name_url}`, '')
        }

        let domainUrl = url.origin.endsWith('/') ? `${url.origin.slice(-1)}`: `${url.origin}`
        
        return <>
            {
                pathname && items.map((item) => {
                    url.search = '';
                    const subcatefilter = item.url;

                    if(item.url?.full) {
                        
                        return <div key={item.name} className={styles.sublink}>
                            <Link href={`${domainUrl}/${item.url?.full}`}>{item.name}</Link>    
                        </div>

                    } else {
                        const subcateUrl = 
                        `${domainUrl}${onlySeoUrl}/${subcatefilter['groupcate']}/${subcatefilter['subcate']}`

                        return <div key={item.name} className={styles.sublink}>
                            <Link href={`${subcateUrl}`}>{item.name}</Link>    
                        </div>
                    }
                })
            }
        </>
    }
    
    return (
        <>
            {
                Object.keys(subcates).map((key) => {
                    return  <div key={key} className={styles.container}>
                        <div className={styles.header}>{key}</div>
                        <div className={styles.subcontainer}>
                            { genSubcate(subcates[key]) }
                        </div>
                    </div>
                })
            }
        </>
    )
}

